import { PublicationStatusSchema } from "../solo-cms/publication-status";
import { z } from "zod";

// ====== Response DTO (read) ======

export const OnboardingStepDtoSchema = z.object({
  id: z.uuid(),
  stepNumber: z.number().int().min(0),
  title: z.string().nullable().optional(),
  videoFileId: z.uuid().nullable().optional(),
  videoUrl: z.string().nullable().optional(),
  descriptionContent: z.string().nullable().optional(),
  descriptionCentered: z.boolean().nullable().optional(),
  publicationStatus: PublicationStatusSchema,
  publishedAt: z.coerce.date().nullable().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type OnboardingStepDto = z.infer<typeof OnboardingStepDtoSchema>;

// ====== Save DTOs (write) ======

const BaseOnboardingStepDtoSchema = z.object({
  stepNumber: z.coerce.number().int().min(0),
  title: z.string().nullable().optional(),
  videoFileId: z.uuid().nullable().optional(),
  descriptionContent: z.string().nullable().optional(),
  descriptionCentered: z.boolean().nullable().optional(),
  publicationStatus: PublicationStatusSchema,
});

export const CreateOnboardingStepDtoSchema = BaseOnboardingStepDtoSchema;
export type CreateOnboardingStepDto = z.infer<typeof CreateOnboardingStepDtoSchema>;

export const UpdateOnboardingStepDtoSchema = BaseOnboardingStepDtoSchema.extend({
  id: z.uuid(),
});
export type UpdateOnboardingStepDto = z.infer<typeof UpdateOnboardingStepDtoSchema>;

export const SaveOnboardingStepDtoSchema = z.union([UpdateOnboardingStepDtoSchema, CreateOnboardingStepDtoSchema]);
export type SaveOnboardingStepDto = z.infer<typeof SaveOnboardingStepDtoSchema>;

// ====== Query params ======

export const GetOnboardingStepByIdQueryParamsSchema = z.object({
  onboardingStepId: z.uuid(),
});
export type GetOnboardingStepByIdQueryParamsDto = z.infer<typeof GetOnboardingStepByIdQueryParamsSchema>;

export const GetOnboardingStepsByPageQueryParamsSchema = z.object({
  page: z.coerce.number().optional(),
  size: z.coerce.number().optional(),
  search: z.string().optional(),
});
export type GetOnboardingStepsByPageQueryParamsDto = z.infer<typeof GetOnboardingStepsByPageQueryParamsSchema>;

export const DeleteOnboardingStepQueryParamsSchema = z.object({
  onboardingStepId: z.uuid(),
});
export type DeleteOnboardingStepQueryParamsDto = z.infer<typeof DeleteOnboardingStepQueryParamsSchema>;

// ====== Result schemas ======

export const GetOnboardingStepsByPageResultSchema = z.object({
  data: z.array(OnboardingStepDtoSchema),
  total: z.number(),
  page: z.number(),
  size: z.number(),
});
export type GetOnboardingStepsByPageResultDto = z.infer<typeof GetOnboardingStepsByPageResultSchema>;

export const GetPublishedOnboardingStepsResultSchema = z.array(OnboardingStepDtoSchema);
export type GetPublishedOnboardingStepsResultDto = z.infer<typeof GetPublishedOnboardingStepsResultSchema>;
